import { useTranslation } from 'react-i18next'

import type { AccountSecurity } from '@/api'
import { Skeleton } from '@/components/Skeleton'
import { SurfaceCard } from '@/components/SurfaceCard'

import { ConnectionRow } from './ConnectionRow'
import { useAccountConnections } from './useAccountConnections'

export const ConnectionsSection = ({ connections }: { connections: AccountSecurity['connections'] | undefined }) => {
    const { t } = useTranslation()
    const connect = useAccountConnections(connections)

    const availableConnections = connections?.filter((connection) => connection.enabled || connection.connected)

    if (availableConnections?.length === 0) {
        return null
    }

    return (
        <SurfaceCard title={t('connections.title')} description={t('connections.description')}>
            {!availableConnections ? (
                <div className="space-y-6" aria-busy="true">
                    {[0, 1].map((index) => (
                        <div key={index} className="flex items-center gap-4">
                            <Skeleton className="h-11 w-11 shrink-0 rounded-full" />
                            <Skeleton className="h-5 w-32" />
                        </div>
                    ))}
                </div>
            ) : (
                <ul className="divide-account-divider -m-6 divide-y">
                    {availableConnections.map((connection) => (
                        <ConnectionRow
                            key={connection.provider}
                            connection={connection}
                            pending={connect.isPending && connect.variables === connection.provider}
                            disabled={connect.isPending || !connection.enabled}
                            onConnect={() => connect.mutate(connection.provider)}
                        />
                    ))}
                </ul>
            )}
        </SurfaceCard>
    )
}
